module.exports = __webpack_public_path__ + "static/media/pro1.22b50f34.jpg";